import { render } from "./newEnjoyShowModel.vue?vue&type=template&id=f1615da0"
import script from "./newEnjoyShowModel.vue?vue&type=script&lang=js"
export * from "./newEnjoyShowModel.vue?vue&type=script&lang=js"

import "./newEnjoyShowModel.vue?vue&type=style&index=0&id=f1615da0&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__